import { getTasks } from '../../api';
import { useProcessedList } from '../../hooks';
import { splitCamelCase } from '../../utilities';
import type { TaskResponse, GetTasksPayload } from '../../api';

export type FiltersType = GetTasksPayload['filters'];
export type ItemType = TaskResponse & {
  task_type_enum: string;
};

export const useTasks = () => {
  return useProcessedList<ItemType, FiltersType>(
    async params => {
      const result = await getTasks({
        filters: params?.filters || {},
        page: { offset: 0, limit: 1_000 },
      });

      return {
        content: result.map(item => ({
          ...item,
          task_type_enum: item.task_type,
          task_type: splitCamelCase(item.task_type),
        })),
      };
    },
    {
      initialFilters: { campaignId: '', status: '', search: '' },
      withLocalSort: true,
      withLocalPagination: true,
      withQueryParams: true,
      searchFilterKey: 'search',
      searchKeys: ['contact_id', 'task_type'],
    }
  );
};
